export default {"src":"/_next/static/media/cog.e956b95f.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};